import { types } from 'mobx-state-tree';
import { SettingsActions } from './Actions/Settings.actions';
import { SettingsModel } from './Models/Settings.model';
import { FeaturesViews } from './Views/Features.views';
import { SettingsViews } from './Views/Settings.views';
const UserSettings = types.model(SettingsModel).actions(SettingsActions).views(SettingsViews).views(FeaturesViews);
export default UserSettings;
